import { Outlet, useParams } from 'react-router-dom';

import TicketListPanel from './TicketListPanel';

export default function TicketsSplitLayout() {
  const { id } = useParams<{ id?: string }>();
  const hasDetail = Boolean(id);

  return (
    <div className={`tickets-split-layout${hasDetail ? ' tickets-split-layout--open' : ''}`}>
      <div className="tickets-split-list">
        <TicketListPanel selectedTicketId={id} compact={hasDetail} />
      </div>
      {hasDetail && (
        <div className="tickets-split-detail">
          <Outlet />
        </div>
      )}
    </div>
  );
}
